export const bookingConstants = {
    BOOKING_FETCHING: 'BOOKING_FETCHING',
    BOOKING_FETCHED: 'BOOKING_FETCHED',
    BOOKING_SUBMITTING: 'BOOKING_SUBMITTING',
    BOOKING_SUBMITTED: 'BOOKING_SUBMITTED',
    BOOKING_SCHEDULES: 'BOOKING_SCHEDULES',
    LIST_OF_BOOKINGS_BY_SCHEDULES: 'LIST_OF_BOOKINGS_BY_SCHEDULES',
    BOOKING_BY_BATCHREF: 'BOOKING_BY_BATCHREF',
    BOOKING_BY_REF: 'BOOKING_BY_REF',
    MULTIPLE_BOOKING_BY_REF: 'MULTIPLE_BOOKING_BY_REF',
    BOOKING_LINK: 'BOOKING_LINK',
    SEARCH_BOOKINGS: 'SEARCH_BOOKINGS',
    BOOKING_FOR_ATW: 'BOOKING_FOR_ATW',
    CY_BRANCH: 'CY_BRANCH',
    CLEAR_MULTIPLE_BOOKING: 'CLEAR_MULTIPLE_BOOKING',
    LIST_OF_BOOKINGS_BY_VOYAGE: 'LIST_OF_BOOKINGS_BY_VOYAGE',
    VOYAGE_FOR_BOOKING_BATCH: 'VOYAGE_FOR_BOOKING_BATCH',
    BOOKING_RESET: 'BOOKING_RESET',
    OPERATION_REPORTS: 'OPERATION_REPORTS',
    BOOKING_PRINT_CBS: 'BOOKING_PRINT_CBS',
    BOOK_REPORTS: 'BOOK_REPORTS',
    BOOK_CSRREPORTS: 'BOOK_CSRREPORTS',
    VOYAGE_HISTORY: 'VOYAGE_HISTORY',
    SQ_BASED_GOODS_REPORT: 'SQ_BASED_GOODS_REPORT',
    VESSEL_HISTORY: 'VESSEL_HISTORY',
    BOOKING_DOCUMENT_TREE: 'BOOKING_DOCUMENT_TREE',
    VOYAGE_SOUNDING: 'VOYAGE_SOUNDING',
    VOYAGE_SOUNDING_PER_YEAR: 'VOYAGE_SOUNDING_PER_YEAR',
    VOYAGE_SOUNDING_PER_MONTH: 'VOYAGE_SOUNDING_PER_MONTH',
    VOYAGE_SOUNDING_PER_VESSEL: 'VOYAGE_SOUNDING_PER_VESSEL',
    VOYAGE_TALLYSHEET_FINALIZE: 'VOYAGE_TALLYSHEET_FINALIZE',
    DWELLTIME_REPORTS: 'DWELLTIME_REPORTS',
    REVENUE_REPORT: 'REVENUE_REPORT',
    REVENUE_REPORT_COMPARATIVE: 'REVENUE_REPORT_COMPARATIVE',
}